import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getChannelHistory } from "../../../api/channels/channelServices";

// import { SKContentStatusHistory } from "../../models/SKArtifact";
import { format } from "date-fns";
import { SKChannelStatusHistory } from "../../../models/SKChannel";
import { capitalizeFirstLetter } from "../../../utils/stringFunctions";
import { useNavigationBar } from "../../../context/NavigationContext";
import { useAuth } from "../../../context/AuthContext";

const MyChannelHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [statusList, setStatusList] = useState<SKChannelStatusHistory[]>([]);
  const { setNavProps } = useNavigationBar();
  const auhtContext = useAuth();

  useEffect(() => {
    setNavProps({
      backArrow: false,

      title: "Status History",
      subtitle: auhtContext?.currentUser?.displayName ?? "",
      buttonTitle: "Done",
      filterOption: true,
      enableLink: false,
      onClose: () => {
        navigate(-1);
      },
    });
  }, [setNavProps, navigate, auhtContext]);

  useEffect(() => {
    const { channelId } = location.state;
    const getHistory = async (id: string) => {
      const statusList = await getChannelHistory(channelId);
      setStatusList(statusList);
    };
    if (channelId) {
      getHistory(channelId);
    }
  }, [location]);

  return (
    <div className="flex flex-col gap-[10px] mt-[15px]">
      {statusList.map((item, index) => {
        return (
          <div key={index} className="relative w-full">
            <div className="flex flex-col w-full">
              <div>
                <p className="history-date">{item.createdDate ? format(item.createdDate.toDate(), "MMM, dd yyyy hh:mm a") : "--"}</p>
              </div>

              <div>
                <p className="history-status">{capitalizeFirstLetter(item.status)}</p>
              </div>
              {item.status && (
                <div>
                  <p className="history-note-reasoncode">{item.reason}</p>
                </div>
              )}

              {item.note && (
                <div>
                  <p className="history-note-reasoncode">{item.note}</p>
                </div>
              )}
            </div>
            <div className="thinseparator mt-[10px]" />
          </div>
        );
      })}
    </div>
  );
};

export default MyChannelHistory;
